












import {Component, Vue} from "vue-property-decorator";

@Component ({
  name: "AutoplayError"
})
export default class AutoplayError extends Vue {

    html?: HTMLDivElement;

    mounted() {
        document.addEventListener("click", this.clickHandler)
    }

    destroyed() {
        document.removeEventListener("click", this.clickHandler);
    }

    clickHandler() {
        this.$emit("click");
    }

    render() {
        return null
    }
}
